const GET_USER_INFO = process.env.VUE_APP_ROOT_API + 'auth/get_user_info.php';

export default{
  namespaced: true,

  state: {

    user: null

  },

  mutations: {
    setUserInfo(state, payload) {
      state.user = payload;
    },
  },

  actions: {
    getUserInfo(context, userId) {
      const { state, commit } = context;

      if (!userId || userId === '-1') {
        return;
      }

      const form = new FormData();
      form.append('user_id', userId);

      return fetch(GET_USER_INFO, {
        credentials: 'include',
        method: 'post',
        body: form
      })
      .then(res => res.json())
      .then(res => {
        commit('setUserInfo', res);
      })
    }
  }
};